require('../../styles/blocks/_applied-promo-code.scss');

const React = require('react');
const PropTypes = require('prop-types');
import { FormattedText } from 'core/i18n';

const AppliedPromoCode = ({ title, description, img }) => {
    return (
        <div className="applied-promo-code">
            <div className="applied-promo-code__fixtitle">
                <FormattedText value="promoCode-promoCode" />
            </div>
            <div className="dash"></div>
            <div className="row">
                <div className={'col-xs-12 col-sm-4 ' + (!img ? 'hidden' : '')}>
                    <img className="img-responsive" src={img} />
                </div>
                <div className="col-xs-12 col-sm-8">
                    <div className="applied-promo-code__title">{title}</div>
                    <div className="applied-promo-code__description">{description}</div>
                </div>
            </div>
        </div>
    );
};

AppliedPromoCode.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

module.exports = AppliedPromoCode;
